import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState } from "react";
import { TvLabel } from "../TvLabel";
import { TvCover } from "../TvCover";
import { TvContent } from "../TvContent";
import { StreamModal } from "../../Video/StreamModal";
import { StreamProvider } from "../PopularVideoSection/StreamContext";
import { useAnalytics } from "../../../utils";
export const TvFrameFullPage = ()=>{
    const { onLiveNowStart  } = useAnalytics();
    const [isOpen, setIsOpen] = useState(false);
    const open = useCallback(()=>{
        setIsOpen(true);
        onLiveNowStart();
    }, []);
    return /*#__PURE__*/ _jsxs(StreamProvider, {
        children: [
            /*#__PURE__*/ _jsxs("section", {
                className: "relative bg-neutral-200 w-full h-[568px] rounded-2xl overflow-hidden lg:h-[635px]",
                children: [
                    /*#__PURE__*/ _jsx(TvCover, {}),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "px-4 pt-8 pb-10 w-full h-full relative bg-transparent flex flex-col justify-between md:px-[30px] md:py-10 lg:px-[116px] lg:pt-[80px] lg:pb-[100px]",
                        children: [
                            /*#__PURE__*/ _jsx(TvLabel, {}),
                            /*#__PURE__*/ _jsx(TvContent, {
                                onClick: open
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(StreamModal, {
                isOpen: isOpen,
                setIsOpen: setIsOpen
            })
        ]
    });
};
